import type { ISubscription } from 'utils/types/Subscription';

export const isActiveSubscriptionStatus = (status?: string): boolean => {
  const normalized = status?.trim().toUpperCase() ?? '';
  return normalized === 'ATIVA' || normalized === 'ACTIVE' || normalized === 'ATIVO';
};

export const hasActiveSubscriptionInList = (
  subscriptions?: ISubscription[],
): boolean =>
  subscriptions?.some(sub => isActiveSubscriptionStatus(sub.status)) ?? false;
